import type { SxProps, Theme } from '@mui/material/styles';

type SxEntry = Extract<SxProps<Theme>, ReadonlyArray<unknown>>[number];

export const mergeSx = (
  ...entries: Array<SxProps<Theme> | undefined>
): SxProps<Theme> =>
  entries.flatMap((entry): ReadonlyArray<SxEntry> => {
    if (Array.isArray(entry)) return entry;

    return entry ? [entry as SxEntry] : [];
  });
